import { UseFormProps } from 'react-hook-form/dist/types/form';

export enum ValidationPatternEnums {
  numberOnly = 'numberOnly',
  email = 'email',
  name = 'name',
  password = 'password',
  url = 'url'
}

export enum ErrorMessageSeverity {
  warning = 1,
  error
}

export enum InputTypes {
  'email' = 'email',
  'hidden' = 'hidden',
  'number' = 'number',
  'password' = 'password',
  'reset' = 'reset',
  'search' = 'search',
  'tel' = 'tel',
  'text' = 'text',
  'url' = 'url'
}

export const FormOptions: UseFormProps = {
  mode: 'onBlur',
  criteriaMode: 'all',
  shouldFocusError: true,
  reValidateMode: 'onChange'
};

export type ValidationPattern = { [key in ValidationPatternEnums]: RegExp };

export const ValidationPatterns: ValidationPattern = {
  [ValidationPatternEnums.numberOnly]: /\d+/,
  [ValidationPatternEnums.email]: /^([a-zA-Z0-9_\-.+]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,31})$/,
  [ValidationPatternEnums.name]: /^[\p{L} ]+$/u,
  [ValidationPatternEnums.password]: /^\S{8,}$/,
  [ValidationPatternEnums.url]:
    /^(?:(?:https?:\/\/)?(?:\d{1,3}\.){3}\d{1,3}(?::\d+)?|(?:https?:\/\/)?(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(?::\d+)?)(?:\/[^\s]*)?$/
};
